import React, { FC } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Questionnaires } from './Questionnaires';


export const QuestionnaireRouter: FC = (props) => {

  const { path } = useRouteMatch();

  return (<Switch>
    <Route exact path={path}>
      <Questionnaires/>
    </Route>
  </Switch>);
};
